import { FunctionComponent, useCallback, useState } from 'react';
import css from './SpamStatusesCard.module.less';
import UserShortCard from '@components/UserShortCard';
import { FULL_TIME_FORMAT } from '@config/format';
import moment from 'moment';
import cn from 'classnames';
import { CalendarOutlined, ForwardOutlined, StopOutlined } from '@ant-design/icons';
import { reset } from '@stores/complaints-reason';
import { ComplaintsReasons } from '@components/SpamUserCard';
import { useStore } from 'effector-react';
import useTranslate from '@hooks/useTranslate';
import componentContent from './SpamStatusesCard.content.json';
import spamStatuses, { block, skip } from '@stores/spamStatuses';
import IStatus from '@interfaces/IStatus';
import { Tag } from 'antd';
interface SpamStausesCardProps {
  status: IStatus;
}

const SpamStatusesCard: FunctionComponent<SpamStausesCardProps> = ({ status }) => {
  const { preloaders } = useStore(spamStatuses);
  const content = useTranslate(componentContent);
  const [reasonsTable, setReasonsTable] = useState<IStatus['claims']>();
  const isLoading = !!preloaders.getList;
  const isSkipping = preloaders.skip === status.id;
  const isBlocking = preloaders.block === status.id;
  const isModerating = isLoading || isSkipping || isBlocking;
  const handleReasonTableOpen = useCallback((value: boolean) => {
    if (value) {
      reset();
      setReasonsTable(status.claims);
    }
  }, []);

  return (
    <div className={css.root}>
      <div className={css.content}>
        <div className={css.user}>
          <UserShortCard user={status.author} />
        </div>

        <div className={css.info}>
          <span className={css.title}>{content.game}</span>
          <Tag color='blue'>{status.game.name}</Tag>
        </div>

        <div className={css.body}>
          <div>
            <span>{status.text}</span>
          </div>
        </div>

        <ComplaintsReasons
          reasonsTable={reasonsTable}
          isLoading={isLoading}
          onOpen={(event) => handleReasonTableOpen(event)}
          status={status}
        />

        <div className={cn(css.metaLine, css.meta)}>
          <div className={css.metaLineItem}>
            <span className={css.metaIcon}>
              <CalendarOutlined />
            </span>
            <span>{moment(status.createDate).format(FULL_TIME_FORMAT)}</span>
          </div>
          <div className={css.metaLineItem}>
            <span className={css.metaIcon}>
              <ForwardOutlined />
            </span>
            <span
              className={cn('clickable', { [css.actionDisabled]: isModerating })}
              onClick={() => {
                if (!isModerating) {
                  skip({ statusId: status.id, preloaderId: status.id });
                }
              }}
            >
              {content.skip}
            </span>
          </div>
          <div className={css.metaLineItem}>
            <span className={css.metaIcon}>
              <StopOutlined />
            </span>
            <span
              className={cn('clickable', { [css.actionDisabled]: isModerating })}
              onClick={() => {
                if (!isModerating) {
                  block({ statusId: status.id, preloaderId: status.id });
                }
              }}
            >
              {content.spam}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpamStatusesCard;
